import type { AreaCatalog } from '../area';
import type { tags as en } from '../en/tags';

export const tags = {
  'tags.page.title': 'Tags',
  'tags.page.notATag': 'Kein Tag.',
  'tags.page.groups': 'Gruppen',
  'tags.page.flows': 'Abläufe',
  'tags.page.subTags': 'Unter-Tags',
  'tags.page.items': 'Aufgaben',
  'tags.page.noItems': 'Keine offene Aufgabe trägt diesen Tag.',
  'tags.page.pager': 'Seiten der Aufgaben mit diesem Tag',
  'tags.count.live': '{count} aktuell',
  'tags.count.dormant': '{count} lange unberührt',
  'tags.count.both': '{live} aktuell · {dormant} lange unberührt',

  'tags.rail.empty':
    'Noch keine Tags. Schreib {example} in einen Titel, um eine Aufgabe zu taggen.',
  'tags.rail.emptyExample': '#wort',
  'tags.rail.filter': 'Tags filtern',
  'tags.rail.noMatch': 'Kein Tag passt.',
  'tags.rail.live': 'Aktuelle Tags',
  'tags.rail.dormant': 'Lange unberührt',
  'tags.rail.dormantTree': 'Lange unberührte Tags',

  'tags.rename.button': 'Umbenennen',
  'tags.retag.title': '#{tag} umbenennen',
  'tags.retag.newName': 'Neuer Name',
  'tags.retag.counting': 'Aufgaben werden gezählt…',
  'tags.retag.reachAll': {
    one: 'Der Tag wird an {count} Aufgabe umbenannt.',
    other: 'Der Tag wird an {count} Aufgaben umbenannt.',
  },
  'tags.retag.reachSome': {
    one: '{act} von {total} Aufgaben. {count} Aufgabe, die du nicht bearbeiten kannst, behält den alten Tag.',
    other:
      '{act} von {total} Aufgaben. {count} Aufgaben, die du nicht bearbeiten kannst, behalten den alten Tag.',
  },
  'tags.retag.confirm': 'Umbenennen',
  'tags.retag.cancel': 'Abbrechen',
  'tags.retag.undo': 'Rückgängig',
  'tags.retag.done': 'OK',
} as const satisfies AreaCatalog<typeof en>;
